<h1 matDialogTitle>
  <ng-container *ngIf="!data?.sim?.id">New Sim</ng-container>
  <ng-container *ngIf="data?.sim?.id">Edit Sim</ng-container>
</h1>
<mat-dialog-content>

  <aw-sim-form [creatingFromBox]="creatingFromBox" (simEmitter)="returnSim($event)" [sim]="data.sim"
    (saved)="dialogRef.close(returnThisInDialogClose)" (canceled)="dialogRef.close(false)"></aw-sim-form>

</mat-dialog-content>